<div class="main-content">
  <app-header
    [title]="(isEdit ? 'USER_FORM.EDIT_TITLE' : 'USER_FORM.CREATE_TITLE') | translate"
    [subtitle]="(isEdit ? 'USER_FORM.EDIT_SUBTITLE' : 'USER_FORM.CREATE_SUBTITLE') | translate"
  />
  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!showSuccess && !showError) {
        <app-icam-container [centralIcon]="true" [iconName]="'user'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
          @if (isLoading) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
          @if (!isLoading) {
            <div class="user-container">
              <form
                class="form-container user-form d-flex flex-column flex-md-row"
                [formGroup]="form"
                (ngSubmit)="onSubmit()"
              >
                <div class="form-section user-config-section w-100">
                  @if ((isCurrentUserAdmin$ | async) && !isEdit) {
                    <div class="input-wrapper mt-4 mb-2 w-100">
                      <button type="button" class="btn btn-outline-danger w-100" (click)="openCreateAdminModal()">
                        {{ 'USER_FORM.CREATE_ADMIN' | translate }}
                      </button>
                    </div>
                  }
                  <div class="mt-3 mb-3">
                    <app-divider [orientation]="'horizontal'"></app-divider>
                  </div>
                  <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
                    <div class="d-flex align-items-center p-1">
                      <img
                        class="section-image"
                        src="../../assets/icon/user-frame-white.svg"
                        alt="role"
                        style="width: 24px; height: 24px"
                      />
                    </div>
                    <div class="form-title-text-container">
                      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                        {{
                          (isAdmin()
                            ? 'USER_FORM.ROLE'
                            : isPartner()
                              ? 'USER_FORM.ROLE_AND_ACCOUNTS'
                              : 'USER_FORM.ROLE_AND_MACHINES'
                          ) | translate
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="input-wrapper mb-2">
                    <label for="role"> {{ 'USER_FORM.ROLE' | translate }}* </label>
                    <select
                      id="role"
                      formControlName="role"
                      class="form-select filter-select rounded-0 fw-bold mt-1"
                      [ngClass]="isLight ? 'light' : 'dark'"
                      [class.is-invalid]="form.get('role')?.invalid && form.get('role')?.touched"
                      [class.no-chevron]="isEdit"
                      [disabled]="isEdit"
                    >
                      <option value="">{{ 'COMMON.CHOOSE_VALUE' | translate }}</option>
                      @for (role of availableRoles; track role) {
                        <option [value]="role.id">
                          {{ role.value | translate }}
                        </option>
                      }
                    </select>
                    @if (form.get('role')?.invalid && (form.get('role')?.touched || form.get('role')?.dirty)) {
                      <div class="invalid-feedback">
                        {{ 'USER_FORM.REQUIRED_FIELD' | translate }}
                      </div>
                    }
                  </div>
                  <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
                    <div class="d-flex align-items-center p-2">
                      <img class="section-image" src="../../assets/icon/user.svg" alt="user" />
                    </div>
                    <div class="form-title-text-container">
                      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                        {{
                          isEdit
                            ? ('USER_FORM.EDIT_USER_CONFIGURATION' | translate)
                            : ('USER_FORM.USER_CONFIGURATION' | translate)
                        }}
                      </p>
                    </div>
                  </div>
                  @if ((isCurrentUserAdmin$ | async) && !isEdit) {
                    <div class="input-wrapper mb-4 w-100">
                      <div class="d-flex  flex-column gap-2">
                        <button
                          type="button"
                          [ngClass]="isLight ? 'btn btn-outline-secondary w-100' : 'btn btn-outline-light w-100'"
                          (click)="openSFContactDialog()"
                          [disabled]="!form.get('role')?.value"
                        >
                          {{ 'USER_FORM.SELECT_SF_CONTACT' | translate }}
                        </button>
                        @if (isCustomer()) {
                          <!-- Disabilitato: ora si abilitano anche contatti senza macchine associate
                          <small class="text-muted mt-1 d-block">
                            {{ 'USER_FORM.CUSTOMER_MACHINES_NOTE' | translate }}
                          </small>
                          -->
                        }
                      </div>
                      <input type="hidden" formControlName="sfContactId" />
                      @if (form.get('sfContactId')?.invalid && form.get('sfContactId')?.touched) {
                        <div class="invalid-feedback d-block">
                          {{ 'USER_FORM.REQUIRED_FIELD' | translate }}
                        </div>
                      }
                    </div>
                  }
                  <app-user-info-section
                    [form]="form"
                    [isEdit]="isEdit"
                    [isLight]="isLight"
                    [isCurrentUserAdmin]="(isCurrentUserAdmin$ | async) ?? false"
                    [isAdminRole]="isAdmin()"
                    [companyGroups]="companyGroups"
                  ></app-user-info-section>
                  <div class="form-section role-machines-section w-100 mt-2 p-0">
                    @if (isPartner()) {
                      <app-accounts-selection
                        [form]="form"
                        [sfContactId]="form.get('sfContactId')?.value"
                        [isPartner]="true"
                        [isEdit]="isEdit"
                        [existingAccounts]="_user.accounts || []"
                        [isCurrentUserAdmin]="(isCurrentUserAdmin$ | async) ?? false"
                        [isLight]="isLight"
                        (accountSelectionChange)="onAccountSelection($event.account, $event.checked)"
                        (accountsLoaded)="onAccountsLoaded()"
                      ></app-accounts-selection>
                    }
                    @if ((!isPartner() || isCustomerPartner()) && !isAdmin()) {
                      <app-machines-selection
                        [form]="form"
                        [sfContactId]="form.get('sfContactId')?.value"
                        [accountIds]="selectedAccountIds"
                        [isPartner]="isPartner()"
                        [isEdit]="isEdit"
                        [existingMachines]="_user.machines || []"
                        [isCurrentUserAdmin]="(isCurrentUserAdmin$ | async) ?? false"
                        [isLight]="isLight"
                        (machineSelectionChange)="onMachineSelection($event.machine, $event.checked)"
                        (machinesLoaded)="onMachinesLoaded()"
                      ></app-machines-selection>
                    }
                  </div>
                  @if (!isAdmin()) {
                    <app-permissions-grid
                      [form]="form"
                      [availablePermissions]="availablePermissions"
                      [isCurrentUserAdmin]="(isCurrentUserAdmin$ | async) ?? false"
                      [isLight]="isLight"
                      (permissionSelectionChange)="onPermissionSelection($event.permissionId, $event.checked)"
                    ></app-permissions-grid>
                  }

                  @if (!isEdit) {
                    <app-credentials-section
                      [form]="form"
                      [isLight]="isLight"
                      [isEdit]="isEdit"
                    ></app-credentials-section>
                  }
                  @if (isCurrentUserAdmin$ | async) {
                    <button
                      type="submit"
                      class="button-form-submit"
                      [class.disabled]="(isSubmitDisabled$ | async) || isLoading"
                      [disabled]="(isSubmitDisabled$ | async) || isLoading"
                    >
                      @if (isLoading) {
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border spinner-border-sm" role="status"></div>
                        </div>
                      } @else {
                        {{ isEdit ? ('USER_FORM.EDIT' | translate) : ('USER_FORM.ENABLE' | translate) }}
                      }
                    </button>
                  }
                </div>
              </form>
            </div>
          }
        </app-icam-container>
      }

      @if (saveSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ (isEdit ? 'USER_FORM.UPDATED_USER' : 'USER_FORM.CREATED_USER') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ (isEdit ? 'USER_FORM.UPDATED_USER_DESCRIPTION' : 'USER_FORM.CREATED_USER_DESCRIPTION') | translate }}
            </p>
          </div>
        </app-icam-container>
      }

      @if (statusChangeSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">
              {{ 'USER_FORM.STATUS_CHANGED' | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ 'USER_FORM.STATUS_CHANGED_DESCRIPTION' | translate }}
            </p>
            <p>{{ 'USER_FORM.REDIRECTING' | translate }}</p>
          </div>
        </app-icam-container>
      }

      @if (saveError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ (isEdit ? 'USER_FORM.UPDATE_ERROR' : 'USER_FORM.CREATE_ERROR') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ (isEdit ? 'USER_FORM.UPDATE_ERROR_DESCRIPTION' : 'USER_FORM.CREATE_ERROR_DESCRIPTION') | translate }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                <p>{{ errorMessage | translate }}</p>
              </div>
            }
          </div>
        </app-icam-container>
      }

      @if (statusChangeError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ 'USER_FORM.STATUS_CHANGED_ERROR_TITLE' | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ 'USER_FORM.STATUS_CHANGED_ERROR_DESCRIPTION' | translate }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                @for (line of errorMessage.split('\n'); track line) {
                  <p>{{ line }}</p>
                }
              </div>
            }
          </div>
        </app-icam-container>
      }

      <div class="form-footer d-flex justify-content-between mt-4">
        <app-back-button
          class="app-back-button"
          [linkText]="'USER_FORM.BACK_TO_USERS'"
          (click)="goBack()"
        ></app-back-button>
        <div class="d-flex flex-row gap-2">
          @if (!isDeleteDisabled()) {
            <button
              type="button"
              [ngClass]="isLight ? 'btn btn-outline-secondary' : 'btn btn-outline-light'"
              (click)="onDeleteUser()"
              [class.disabled]="!form.valid || isLoading"
              [disabled]="!form.valid || isLoading"
            >
              @if (isLoading) {
                <div class="d-flex justify-content-center">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </div>
              } @else {
                {{ 'USER_FORM.ON_DELETE' | translate }}
              }
            </button>
          }

          @if (
            (isCurrentUserAdmin$ | async) &&
            isEdit &&
            !saveSuccess &&
            !statusChangeSuccess &&
            !saveError &&
            !statusChangeError &&
            form.get('status')?.value !== 'INACTIVE'
          ) {
            <button
              type="button"
              [ngClass]="isLight ? 'btn btn-outline-secondary' : 'btn btn-outline-light'"
              (click)="onDeactivateUser()"
              [class.disabled]="!form.valid || isLoading"
              [disabled]="!form.valid || isLoading"
            >
              @if (isLoading) {
                <div class="d-flex justify-content-center">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </div>
              } @else {
                {{ 'USER_FORM.DEACTIVATE_USER_BUTTON' | translate }}
              }
            </button>
          }

          @if (
            (isCurrentUserAdmin$ | async) &&
            isEdit &&
            !saveSuccess &&
            !statusChangeSuccess &&
            !saveError &&
            !statusChangeError &&
            form.get('status')?.value === 'INACTIVE'
          ) {
            <button
              type="button"
              ngClass="btn btn-outline-danger"
              (click)="onActivateUser()"
              [class.disabled]="!form.valid || isLoading"
              [disabled]="!form.valid || isLoading"
            >
              @if (isLoading) {
                <div class="d-flex justify-content-center">
                  <div class="spinner-border spinner-border-sm" role="status"></div>
                </div>
              } @else {
                {{ 'USER_FORM.ACTIVATE_USER_BUTTON' | translate }}
              }
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer-copyright />
